<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-01-20 09:27:04
 * @LastEditTime : 2025-09-18 10:24:11
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\settleExport.vue
-->
<template>
    <el-dialog v-dialogDrag title="导出" :visible.sync="visible" width="1200px" :close-on-click-modal="false" @close="onClose"
        @open="onOpen">
        <iframe id="transport" :src="frSrc" scrolling="no" frameborder="0"></iframe>
        <span slot="footer" class="dialog-footer">
            <el-button class="bottom_all_two" @click="onClose">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        exportForm: {
            type: Object,
            default: () => { }
        },
        isNode: {
            type: Number,
            default: 1,
        }
    },
    data() {
        return {
            form: {},
            frSrc: "",
        }
    },
    mounted() {
        /**
         * iframe-宽高自适应显示
         */

    },
    methods: {
        onOpen() {
            let nodeList = `&isNode=${encodeURIComponent(this.isNode)}&nodeName=${encodeURIComponent(this.exportForm.nodeName)}&userName=${encodeURIComponent(this.exportForm.userName)}&multiApprovalType=${encodeURIComponent(this.exportForm.multiApprovalType)}&approvalOptions=${encodeURIComponent(this.exportForm.approvalOptions)}&handlerTime=${encodeURIComponent(this.exportForm.handlerTime)}&approvalStatus=${encodeURIComponent(this.exportForm.approvalStatus)}`;

            if (this.exportForm.dataType == 1) {
                this.frSrc = `https://bi.huashijc.com/fr/decision/view/report?viewlet=ICPS%252F%25E6%25A0%25B8%25E5%25AF%25B9%25E6%2598%258E%25E7%25BB%2586%25E5%258D%2595.cpt&ref_t=design&ref_c=f2f1b2f2-bda3-4ea6-a3b6-b666b57af7d4&cycleManageId=${encodeURIComponent(this.exportForm.cycleManageId)}&checkDetailType=${encodeURIComponent(this.exportForm.checkDetailType)}&engineeringName=${encodeURIComponent(this.exportForm.engineeringName)}&lastDueTime=${encodeURIComponent(this.exportForm.lastDueTime)}&currentDueTime=${encodeURIComponent(this.exportForm.currentDueTime)}&partyA=${encodeURIComponent(this.exportForm.partyA)}&partyB=${encodeURIComponent(this.exportForm.partyB)}` + nodeList
            }

            if (this.exportForm.dataType == 2) {
                this.frSrc = `https://bi.huashijc.com/fr/decision/view/report?viewlet=ICPS%252F%25E6%25B7%25B7%25E5%2587%259D%25E5%259C%259F%25E7%25BB%2593%25E7%25AE%2597.cpt&ref_t=design&ref_c=f2f1b2f2-bda3-4ea6-a3b6-b666b57af7d4&__bypagesize__=false&cycleManageId=${encodeURIComponent(this.exportForm.cycleManageId)}&engineeringName=${encodeURIComponent(this.exportForm.engineeringName)}&lastDueTime=${encodeURIComponent(this.exportForm.lastDueTime)}&currentDueTime=${encodeURIComponent(this.exportForm.currentDueTime)}&partyA=${encodeURIComponent(this.exportForm.partyA)}&partyB=${encodeURIComponent(this.exportForm.partyB)}` + nodeList;
            }

            if (this.exportForm.dataType == 3) {
                this.frSrc = `https://bi.huashijc.com/fr/decision/view/report?viewlet=ICPS%252F%25E6%25B7%25B7%25E5%2587%259D%25E5%259C%259F%25E7%25BB%2593%25E7%25AE%2597%25E7%25A1%25AE%25E8%25AE%25A4%25E9%2587%258F.cpt&ref_t=design&ref_c=f2f1b2f2-bda3-4ea6-a3b6-b666b57af7d4&__bypagesize__=false&cycleManageId=${encodeURIComponent(this.exportForm.cycleManageId)}&engineeringName=${encodeURIComponent(this.exportForm.engineeringName)}&lastDueTime=${encodeURIComponent(this.exportForm.lastDueTime)}&currentDueTime=${encodeURIComponent(this.exportForm.currentDueTime)}&partyA=${encodeURIComponent(this.exportForm.partyA)}&partyB=${encodeURIComponent(this.exportForm.partyB)}` + nodeList;
            }

            function changeMobsfIframe() {
                const mobsf = document.getElementById("transport");
                //   const deviceWidth = document.body.clientWidth;
                const deviceHeight = document.body.clientHeight;
                mobsf.style.width = "1140px"; //数字是页面布局宽度差值
                mobsf.style.height = Number(deviceHeight) - 200 + "px"; //数字是页面布局高度差
            }
            this.$nextTick(() => {
                changeMobsfIframe();
                window.onresize = function () {
                    changeMobsfIframe();
                };
            })
            console.log(this.frSrc)
        },
        onClose() {
            this.$emit('update:visible', false);
        },
    }
}
</script>
<style lang="scss" scoped></style>


